"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../CustomerTable.vue");
var _moment = _interopRequireDefault(require("moment"));
var _staff = require("@/api/staff");
var _initStore = require("@/store/initStore");
var _ghn = require("@/api/ghn");
var CustomerInfoForm = /*#__PURE__*/function (_Vue) {
  function CustomerInfoForm() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerInfoForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerInfoForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "rules", void 0);
    (0, _defineProperty2.default)(_this, "visible", void 0);
    (0, _defineProperty2.default)(_this, "status", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "GenderType", _CustomerTable.GenderType);
    (0, _defineProperty2.default)(_this, "GenderTypeTrans", _CustomerTable.GenderTypeTrans);
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "logo", require("@/assets/images/logo.png"));
    return _this;
  }
  (0, _inherits2.default)(CustomerInfoForm, _Vue);
  return (0, _createClass2.default)(CustomerInfoForm, [{
    key: "progress",
    get: function get() {
      if (!this.form.nextRank.amount) {
        return 100;
      }
      var ratio = this.form.totalSale / this.form.nextRank.amount;
      if (ratio >= 1) {
        return 100;
      }
      return ratio * 100;
    }
  }, {
    key: "remainAmount",
    get: function get() {
      if (!this.form.nextRank) {
        return 0;
      }
      return this.form.nextRank.amount - this.form.totalSale;
    }
  }, {
    key: "age",
    get: function get() {
      return (0, _moment.default)().diff((0, _moment.default)(this.form.birthday, "DD/MM/YYYY").valueOf(), "years", false) || "--";
    }
  }, {
    key: "checkGroupRetail",
    get: function get() {
      var _this2 = this;
      var group = this.$store.state.customerGroup.list.find(function (e) {
        return e.id == _this2.form.customerGroupId;
      });
      if ((group === null || group === void 0 ? void 0 : group.name) == "Retail") {
        return true;
      }
      return false;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchStaffs();
      this.fetchCities();
    }
  }, {
    key: "watchCity",
    value: function watchCity(val) {
      if (!val) {
        return;
      }
      this.fetchDistricts();
    }
  }, {
    key: "watchVisible",
    value: function watchVisible(val) {
      if (val) {
        _initStore.skinStatusStore.fetchData();
        _initStore.customerRankStore.fetchData();
        _initStore.customerGroupStore.fetchData();
        _initStore.customerSourceStore.fetchData();
      }
    }
  }, {
    key: "handleChangeWard",
    value: function handleChangeWard() {
      var _this3 = this;
      var ward = this.wards.find(function (e) {
        return e.WardCode == _this3.form.receiverWardCode;
      });
      this.form.receiverWardName = ward && ward.WardName;
    }
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      var _this4 = this;
      this.form.receiverWardCode = null;
      var district = this.districts.find(function (e) {
        return e.DistrictID == _this4.form.receiverDistrictId;
      });
      this.form.receiverDistrictName = district && district.DistrictName;
      this.form.receiverDistrictCode = district && district.Code;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      var _this5 = this;
      this.$set(this.form, "receiverDistrictId", null);
      this.$set(this.form, "receiverWardCode", null);
      var city = this.cities.find(function (e) {
        return e.ProvinceID == _this5.form.receiverCityId;
      });
      this.form.receiverCityName = city && city.ProvinceName;
      this.form.receiverCityCode = city && city.Code;
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      this.fetchWards();
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: this.form.receiverCityId
              });
            case 2:
              res = _context2.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ghn.ghnApi.findWard({
                district_id: this.form.receiverDistrictId
              });
            case 2:
              res = _context3.sent;
              this.wards = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this6 = this;
      _staff.staffApi.findAll().then(function (res) {
        _this6.staffs = res.data.data;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerInfoForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerInfoForm.prototype, "rules", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerInfoForm.prototype, "visible", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerInfoForm.prototype, "status", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverCityId", {
  deep: true,
  immediate: true
})], CustomerInfoForm.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("visible", {
  immediate: true
})], CustomerInfoForm.prototype, "watchVisible", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverDistrictId", {
  deep: true,
  immediate: true
})], CustomerInfoForm.prototype, "watchDistrictId", null);
CustomerInfoForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], CustomerInfoForm);
var _default = exports.default = CustomerInfoForm;